import { IMetadata } from '@carm/_core';
import { createAction, props } from '@ngrx/store';

export const loadAllMetadata = createAction(
  '[Metadata] Load all metadata',
   props<{ lang: string }>(),
);

export const loadAllMetadataSuccess = createAction(
  '[Metadata] Load all metadata Success',
   props<{ data: IMetadata[] }>(),
);

export const loadAllMetadataFailure = createAction(
  '[Metadata] Load all metadata Failure',
  props<{ error: any }>(),
);

export const removeAllMetadata = createAction(
  '[Metadata] Remove all metadata',
);

export const loadSingleMetadata = createAction(
  '[Metadata] Load Specific metadata',
   props<{ lang: string, id: string }>(),
);

export const loadSingleMetadataSuccess = createAction(
  '[Metadata] Load Specific metadata Success',
   props<{ data: IMetadata }>(),
);

export const loadSingleMetadataFailure = createAction(
  '[Metadata] Load Specific metadata Failure',
  props<{ error: any }>(),
);
